import React, { Component } from "react";
import { Select } from "antd";
import axios from "axios";
import cuentaMask from "./cuentaMask";

const { Option } = Select;

class SelectCuentaContableItem extends Component {
  constructor(props) {
    super(props);
    this.state = { opciones: [], cargando: false };
  }

  componentDidMount() {
    this.cargarCuentas();
  }

  async cargarCuentas() {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "cuentascontables/selectCuentasContables",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      this.setState({ opciones: Array.isArray(res.data) ? res.data : [] });
    } catch (error) {
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const { empresaId, headersToken, width, onChange, ...restProps } = this.props;
    return (
      <Select
        showSearch
        optionFilterProp="children"
        loading={this.state.cargando}
        style={{ width: width || "100%" }}
        {...restProps}
        onChange={(value) => {
          const cuenta = this.state.opciones.find((c) => c._id === value);
          if (onChange) onChange(value, cuenta);
        }}
      >
        {this.state.opciones.map((cuenta) => (
          <Option value={cuenta._id} key={cuenta._id}>
            {cuentaMask(
              (cuenta.nivel1 || "") +
                (cuenta.nivel2 || "") +
                (cuenta.nivel3 || "") +
                (cuenta.nivel4 || "") +
                (cuenta.nivel5 || "")
            ) +
              " - " +
              cuenta.descripcion}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectCuentaContableItem;
